import {Box, Flex, Heading, Text, Input, Grid, GridItem} from "@chakra-ui/react";
import moment from "moment";
import {InputLabel, Textarea} from "../../../components/Theme";
import styles from "./styles";
import Loading from "../../../components/Loading";
import Luminaires from "./parts/Luminaires";
import {REU} from "../../../constants/user/userEnum";
import DatePicker from "react-modern-calendar-datepicker";
import {useEffect, useMemo} from "react";

const EstimateTab = ({
                         refererEstimate,
                         estimate,
                         luminaires,
                         subTotal,
                         notes,
                         setShipping,
                         setSalesTax,
                         setNotes,
                         salesTax,
                         shipping,
                         total,
                         depositAmount,
                         depositDue,
                         remainderDue,
                         remainderAmount,
                         setRemainderAmount,
                         setDepositAmount,
                         setDepositDue,
                         setRemainderDue,
                         user,
                         isLoading,
                     }) => {

    const { calculatedSubTotal, calculatedTotal, calculatedRemainder } = useMemo(() => {
        let sub = 0;

        const cleanPpu = (val) => {
            if (!val) return 0;
            if (typeof val === 'string') return Number(val.replace(/[^0-9.]/g, ''));
            return Number(val);
        };

        estimate?.luminaires?.forEach(item => {
            console.log(item)
            const isLamp = item?.lampRecomendedAirtable && item.lampRecomendedAirtable.length > 0;
            let targetFields = null;
            if (isLamp) {
                try {
                    targetFields = JSON.parse(item.lampRecomendedAirtable);
                } catch (e) {
                    console.error("Error parsing lamp data: ", e);
                }
            } else if (item?.fixtureRecomendedAirtableArray?.length > 0) {
                targetFields = item.fixtureRecomendedAirtableArray[0]['fields'];
            }

            const lampQty = item.recomendedLampQty ? Number(item.recomendedLampQty) : 1;
            const fixtureQty = item.qty ? Number(item.qty) : (item.recomendedFixtureQty ? Number(item.recomendedFixtureQty) : 1);
            const mainQty = isLamp ? (lampQty * fixtureQty) : fixtureQty;

            if (targetFields) {
                const customPpu = targetFields?.['SU PPU ($) Custom FE'];
                const vol1Ppu = targetFields?.['FE PPU Vol1 ($)'];
                const vol2Ppu = targetFields?.['FE PPU Vol2 ($)'];
                const standardPpu = targetFields?.['FE PPU ($)'];

                let ppu = 0;
                if (customPpu) {
                    ppu = Number(customPpu);
                } else if (mainQty >= 100 && mainQty < 200) {
                    ppu = cleanPpu(vol1Ppu) || 1;
                } else if (mainQty >= 200) {
                    ppu = cleanPpu(vol2Ppu) || 1;
                } else {
                    ppu = cleanPpu(standardPpu) || 0;
                }
                sub += (ppu * mainQty);
            }
            const getExtraTotal = (fields, totalQty) => {
                if (!fields) return 0;
                const extCustomPpu = fields?.['SU PPU ($) Custom FE'];
                const extVol1Ppu = cleanPpu(fields?.['FE PPU Vol1 ($)']);
                const extVol2Ppu = cleanPpu(fields?.['FE PPU Vol2 ($)']);
                const extStandardPpu = cleanPpu(fields?.['FE PPU ($)']);

                let exPpu = 0;
                if (extCustomPpu) {
                    exPpu = Number(extCustomPpu);
                } else if (totalQty >= 100 && totalQty < 200) {
                    exPpu = extVol1Ppu || 1;
                } else if (totalQty >= 200) {
                    exPpu = extVol2Ppu || 1;
                } else {
                    exPpu = extStandardPpu || 0;
                }
                return exPpu * totalQty;
            };
            let powerFields = null;
            if (item?.powerSupplyRecomendedAirtableArray?.length > 0) {
                powerFields = item.powerSupplyRecomendedAirtableArray[0]['fields'] || item.powerSupplyRecomendedAirtableArray[0];
            }
            const powerBaseQty = item.powerSupplyRecomendedQty ? Number(item.powerSupplyRecomendedQty) : (item.powerQTYFixture ? Number(item.powerQTYFixture) : 1);
            sub += getExtraTotal(powerFields, fixtureQty * powerBaseQty);

            // 3. Controls
            let controlFields = null;
            if (item?.controlRecomendedAirtableArray?.length > 0) {
                controlFields = item.controlRecomendedAirtableArray[0]['fields'] || item.controlRecomendedAirtableArray[0];
            }
            const controlBaseQty = item.controlRecomendedQty ? Number(item.controlRecomendedQty) : 1;
            sub += getExtraTotal(controlFields, fixtureQty * controlBaseQty);

            let accessoryFields = null;
            if (item?.accessoryRecomendedAirtableArray?.length > 0) {
                accessoryFields = item.accessoryRecomendedAirtableArray[0]['fields'] || item.accessoryRecomendedAirtableArray[0];
            }
            const accessoryBaseQty = item.accessoryRecomendedQty ? Number(item.accessoryRecomendedQty) : 1;
            sub += getExtraTotal(accessoryFields, fixtureQty * accessoryBaseQty);
        });

        const tot = sub + Number(salesTax || 0) + Number(shipping || 0);
        const rem = tot - Number(depositAmount || 0);

        return {
            calculatedSubTotal: sub,
            calculatedTotal: tot,
            calculatedRemainder: rem
        };
    }, [estimate?.luminaires, salesTax, shipping, depositAmount]);

    useEffect(() => {
        if (setRemainderAmount) {
            setRemainderAmount(calculatedRemainder);
        }
    }, [calculatedRemainder, setRemainderAmount]);


    if (isLoading) return <Loading/>

    return (
        <Box ref={refererEstimate} display={estimate?.createdAt ? 'block' : 'none'} backgroundColor='white' p={9}>
            <Flex justifyContent='space-between'>
                <img src="/images/LogoIcon.svg" alt="logo"/>
                <Flex flexDirection='column'>
                    <Heading m={0} textAlign='end'>Estimate</Heading>
                    <Text>Reference # : {estimate?.reference}</Text>
                    <Text textAlign='end'>Date : {moment(estimate?.createdAt?.date)?.format('MM/DD/YYYY')}</Text>
                </Flex>
            </Flex>
            <Flex mt={4} justifyContent='space-between' fontSize='18px'>
                <Flex width='49%' borderRight='2px solid #9C9C9C' flexDirection='column'>
                    <Input readOnly border='none' fontFamily='Titillium Web' backgroundColor='#EEEEEE' width='98%' fontSize='18px' mb={3}
                           value='Billing Information:' color='#222222' fontWeight='700'/>
                    <Text>Focus Earth</Text>
                    <Text>Attn: Pete Musser</Text>
                    <Text>1070 Tunnel Road</Text>
                    <Text>Building 1, Suite 10, #202</Text>
                    <Text>Asheville, NC 28805</Text>
                    <Text>USA</Text>
                    <Text>(925) 323-0053</Text>
                </Flex>
                <Flex width='50%' flexDirection='column'>
                    <Input fontFamily='Titillium Web' readOnly border='none' backgroundColor='#EEEEEE' width='100%' fontSize='18px' mb={3}
                           value='Shipping Information:' color='#222222' fontWeight='700'/>
                    <Text>{estimate?.userReu?.company?.length > 0 ? estimate?.userReu?.company[0]?.name : estimate?.userReu?.associatedToCompany?.name}</Text>
                    <Text>Attn : {estimate?.userReu?.firstName + ' ' + estimate?.userReu?.lastName}</Text>
                    <Text>{estimate?.report?.project?.address}</Text>
                    <Text>{estimate?.report?.project?.address2}</Text>
                    <Text>{estimate?.report?.project?.city + ', ' + estimate?.report?.project?.state + ', ' + estimate?.report?.project?.zipCode}</Text>
                    <Text>USA</Text>
                    <Text>{estimate?.userReu?.phone}</Text>
                </Flex>
            </Flex>
            <Input fontFamily='Titillium Web' readOnly border='none' backgroundColor='#8FCF74' width='100%' fontSize='18px' fontWeight='700'
                   color='#222222' value='Order Information' mt={10}/>
            <Grid templateColumns='repeat(7, 1fr)' my={5} px={4}>
                <GridItem colSpan={3} as='h2' m={0}>
                    Description
                </GridItem>
                <GridItem colSpan={1} as='h2' m={0} textAlign='center'>
                    Part Number
                </GridItem>
                <GridItem colSpan={1} as='h2' m={0} textAlign='center'>
                    QTY
                </GridItem>
                <GridItem colSpan={1} as='h2' m={0} textAlign='center'>
                    Price Per Unit
                </GridItem>
                <GridItem colSpan={1} as='h2' m={0} textAlign='center'>
                    Amount
                </GridItem>
            </Grid>
            <Luminaires luminaires={luminaires}/>
            <Flex justifyContent='end' mt={7}>
                <Flex width='50%' fontWeight='700' border='2px solid #8FCF74' height='64px' alignItems='center'
                      justifyContent='space-between' pl={6} pr={2} borderRadius='6px'>
                    <Input readOnly fontWeight='600' border='none' fontFamily='Titillium Web' value='Sub Total:' fontSize='18px'/>
                    <Flex justifyContent='end'>
                        <Input fontFamily='Titillium Web' readOnly border='none' fontSize='14px' fontWeight='600'
                               value={calculatedSubTotal ? '$' + calculatedSubTotal?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '$0.00'}/>
                    </Flex>
                </Flex>
            </Flex>
            <Flex fontSize='18px !important' justifyContent='space-between'>
                <Flex width='50%' flexDirection='column'>
                    <Text mb={2} color='#2C628D' fontWeight='700' fontFamily='Titillium Web'>Notes:</Text>
                    <Textarea fontSize='18px !important' disabled={user?.type === REU} value={notes}
                              onChange={(e) => setNotes(e.target.value)} minH='130px'/>
                </Flex>
                <Flex flexDirection='column' color='#2C628D' mt={7}>
                    <Flex alignItems='center' justifyContent='space-between' minW='230px'>
                        <Text fontFamily='Titillium Web' textAlign='right'>Sales Tax:</Text>
                        <InputLabel css={styles.centeredInput}
                                    placeholder={0}
                                    leftAddon='$'
                                    disabled={user?.type === REU}
                                    onChange={(e) => setSalesTax(e.target.value.replace(/[^0-9.-]+/g, ''))}
                                    value={salesTax ? Number(salesTax)?.toLocaleString('en-US'): 0}
                                    maxW='137px'/>
                    </Flex>
                    <Flex alignItems='center' justifyContent='space-between'>
                        <Text fontFamily='Titillium Web' >Shipping:</Text>
                        <InputLabel css={styles.centeredInput}
                                    placeholder={0}
                                    leftAddon='$'
                                    disabled={user?.type === REU}
                                    onChange={(e) => setShipping(e.target.value.replace(/[^0-9.-]+/g, ''))}
                                    value={shipping ? Number(shipping)?.toLocaleString('en-US') : 0} maxW='137px'/>
                    </Flex>
                    <Flex alignItems='center' justifyContent='space-between'>
                        <Text fontFamily='Titillium Web' fontWeight='700' textAlign='right' minW='70px'>Total:</Text>
                        <InputLabel
                            placeholder={0}
                            readOnly disabled={user?.type === REU}
                            value={'$' + calculatedTotal?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}  style={{'border': '2px solid #8FCF74'}} maxW='137px'/>
                    </Flex>
                </Flex>
            </Flex>
            <Flex justifyContent='space-between'>
                <Flex width='50%' flexDirection='column' fontSize='14px'>
                    <Flex width='full' fontWeight='700' mt={8}>
                        <Box width='45%' fontFamily='Titillium Web' fontWeight='700'>Payment Terms:</Box>
                        <Text fontWeight='normal' width='55%'>50% Deposit due upon order placement<br/>50% Remainder due
                            upon Delivery</Text>
                    </Flex>
                    <Flex fontWeight='700' mt={8}>
                        <Box width='45%' fontFamily='Titillium Web' fontWeight='700'>Make Checks Payable To:</Box>
                        <Text fontWeight='normal' color='#619C48' width='55%'>Focus Earth</Text>
                    </Flex>
                    <Flex fontWeight='700' mt={5}>
                        <Box width='45%' fontFamily='Titillium Web' fontWeight='700'>Mail To:</Box>
                        <Text fontWeight='normal' width='55%'>1070 Tunnel Road <br/> Building 1, Suite 10,
                            #202 <br/> Asheville, NC 28805</Text>
                    </Flex>
                    <Flex fontWeight='700' mt={5}>
                        <Box width='45%' fontFamily='Titillium Web' fontWeight='700'>Electronic Payment:</Box>
                        <Text fontWeight='normal' width='55%'>Email accounting@focusearth.com</Text>
                    </Flex>
                </Flex>
                <Flex maxW='50%' fontSize='18px !important' flexDirection='column' justifyContent='end' color='#2C628D'>
                    <Flex alignItems='center' justifyContent='end'>
                        <Text ml='20px' fontFamily='Titillium Web'>Deposit Amount:</Text>
                        <InputLabel css={styles.centeredInput}
                                    placeholder='0'
                                    leftAddon='$'
                                    disabled={user?.type === REU} onChange={(e) => setDepositAmount(e.target.value.replace(/[^0-9.-]+/g, ''))}
                                    value={depositAmount ? Number(depositAmount)?.toLocaleString('en-US') : 0} ml='20px' maxW='137px'/>
                    </Flex>
                    <Flex alignItems='center' justifyContent='end' css={styles.datePicker}>
                        <Text ml='20px' fontFamily='Titillium Web'>Deposit Due:</Text>
                        <DatePicker
                            name="startDate"
                            inputPlaceholder="Select a date"
                            selected={depositDue}
                            onChange={(date) => setDepositDue(date)}
                            format="YYYY / MM / DD"
                            disabled={user?.type === REU}
                            className='test-class'
                            wrapperClassName='wrapper-class'
                            calendarClassName='calendar-class'
                            formatInputText={() => {
                                if (!depositDue) return '';
                                return `${depositDue.month.toString().padStart(2, '0')}.${depositDue.day.toString().padStart(2, '0')}.${depositDue.year}`;
                            }}
                            value={depositDue}
                        />
                    </Flex>
                    <Flex alignItems='center' justifyContent='end'>
                        <Text ml='20px' fontFamily='Titillium Web'>Remainder Amount:</Text>
                        <InputLabel leftAddon='$' css={styles.centeredInput} readOnly ml='20px'
                                    disabled={user?.type === REU} value={calculatedRemainder?.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})} maxW='137px'/>
                    </Flex>
                    <Flex alignItems='center' justifyContent='end' css={styles.datePicker}>
                        <Text ml='20px' fontFamily='Titillium Web'>Remainder Due:</Text>
                        <DatePicker
                            name="startDate"
                            selected={remainderDue}
                            onChange={(date) => setRemainderDue(date)}
                            format="YYYY / MM / DD"
                            disabled={user?.type === REU}
                            className='test-class'
                            wrapperClassName='wrapper-class'
                            inputPlaceholder="Select a date"
                            calendarClassName='calendar-class'
                            formatInputText={() => {
                                if (!remainderDue) return '';
                                return `${remainderDue.month.toString().padStart(2, '0')}.${remainderDue.day.toString().padStart(2, '0')}.${remainderDue.year}`;
                            }}
                            value={remainderDue}
                        />
                    </Flex>
                </Flex>
            </Flex>
        </Box>
    )
}
export default EstimateTab